import React, {Component} from 'react';
import * as echarts from 'echarts';
import svg from '../img/logo.svg'

class Databg extends Component {
    constructor(props) {
        super(props);
        // 绘制图表
        let option = {
            backgroundColor:'rgba(128, 128, 128, 0)',
            tooltip: {},
            geo: {
                map: 'ksia-ext-plan',
                layoutCenter: ['50%', '50%'],
                layoutSize: '100%'
            },
            series: [
                {
                    name: 'Route',
                    type: 'lines',
                    coordinateSystem: 'geo',
                    geoIndex: 0,
                    polyline: true,
                    lineStyle: {
                        color: '#FF8D50',
                        width: 1
                    },
                    effect: {
                        show: true,
                        period: 8,
                        color: '#3BD7F7',
                        trailLength: 0,
                        symbolSize: [10, 40],
                        symbol:'roundRect'

                    },
                    z: 100,
                    data: [
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-350, -180],
                                [-200, -180]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-200, -180],
                                [-50, -180]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-50, -180],
                                [100, -180]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [100, -180],
                                [250, -180]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-350, 50],
                                [-200, 50]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-200, 50],
                                [-50, 50]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-50, 50],
                                [100, 50]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [100, 50],
                                [250, 50]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-350, 280],
                                [-200, 280]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-200, 280],
                                [-50, 280]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [-50, 280],
                                [100, 280]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [100, 280],
                                [250, 280]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [500, 320],
                                [500, 450]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [500, 450],
                                [500, 580]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [500, 580],
                                [500, 710]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1000, 320],
                                [1000, 450]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1000, 450],
                                [1000, 580]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1000, 580],
                                [1000, 710]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1300, 750],
                                [1470, 750]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1470, 750],
                                [1640, 750]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1640, 750],
                                [1810, 750]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1810, 750],
                                [1980, 750]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1300, 980],
                                [1470, 980]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1470, 980],
                                [1640, 980]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1640, 980],
                                [1810, 980]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1810, 980],
                                [1980, 980]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1300, 1220],
                                [1470, 1220]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1470, 1220],
                                [1640, 1220]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1640, 1220],
                                [1810, 1220]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [1810, 1220],
                                [1980, 1220]
                            ]
                        },
                        {
                            effect: {
                                constantSpeed: 100,
                                delay: 0
                            },
                            coords: [
                                [240, 840],
                                [0, 840]
                            ]
                        }
                    ]
                }
            ]
        };
        this.state = {
            option: option,
            array: []
        };
    }

    componentDidMount() {
        fetch(svg)
            .then(res => res.text())
            .then(
                (result) => {
                    let option = this.state.option;

                    // 基于准备好的dom，初始化echarts实例
                    var myChart = echarts.init(document.getElementById('databg'),'dark');
                    echarts.registerMap('ksia-ext-plan', { svg: result });
                    //点击事件
                    myChart.on('click', function (params) {
                        //window.open('/list?area=' + encodeURIComponent(params.data.id), '_self');
                    });
                    myChart.setOption((option));
                    option && myChart.setOption(option);
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    render() {
        return (
            <div id="databg" className="mapgb"></div>
        )
    }
}

export default Databg;
